<template>
  <div class="match-footer">
    <div class="match-container">
      <div class="match-live-signal" :class="filtered.$partClass">
        <span
          v-for="(item, index) in signalRows"
          :key="index"
          class="signal-row"
        >
          {{ item.label }}: {{ item.value }}
      </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  filtered: {
    type: Object,
    default: () => ({}),
  },
});

const signalRows = computed(() => {
  console.log(props.filtered);
  if (!props.filtered.signal) return [];
  return [
    { label: "Minute", value: props.filtered.signal.time },
    { label: "Score", value: props.filtered.signal.score },
    { label: "Type", value: props.filtered.type },
    { label: "Market", value: `${props.filtered.signal.market} ${props.filtered.signal.total}` },
    { label: "Odds", value: props.filtered.signal.fakeOdds || props.filtered.signal.odds },
  ];
});
</script>

<style scoped>
.signal-row {
  margin: 0 6px;
  white-space: nowrap;
}
.match-footer {
  padding: 10px;
  border-top: 1px solid #ddd;
}
.match-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  text-align: center;
}
.match-live-signal {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 3px 5px;
  border-radius: 10px;
  text-transform: capitalize;
}
</style>
